<style lang="less" scoped>
.h5-about-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .flex-1 {
    flex: 1;
  }
  font-size: 12px;
}
.h5-content-div {
  margin: 16px;
  padding: 0 0 16px 0;
}
.topic-title {
  text-align: center;
  font-weight: 900;
  line-height: 32px;
}
.content-div {
  text-indent: 2em;
}
.line-topic-title {
  font-weight: 900;
  line-height: 30px;
  height: 30px;
}

.table-content-div {
  width: 100%;
  overflow-x: scroll;
}
.policy-table {
  width: 100%;
  border-collapse: collapse;
}
.policy-table tr {
  height: 32px;
  line-height: 32px;
}
.policy-table tr th {
  padding-left: 2px;
}
.policy-table tr td {
  padding-left: 2px;
}
.policy-a {
  text-decoration: underline;
  cursor: pointer;
  word-wrap: break-word;
  word-break: break-all;
}

.width-1 {
  width: 20% !important;
}
</style>

<template>
  <div class="h5-about-container">
    <div class="h5-content-div">
      <div class="topic-title">桩权益服务协议</div>

      <div class="line-topic-title">
        1. 服务条款的接受与修改
      </div>
      <div class="content-div">
        1.1
        本协议是上海挚达科技发展股份有限公司所完全拥有的挚达APP所提供的桩权益服务，关于在挚达APP购买桩权益服务套餐并通过挚达APP在已购买挚达私人充电桩延长桩权益服务之间所订立的协议。
      </div>
      <div class="content-div">
        本协议描述挚达APP与购买桩权益服务用户之间关于桩劝你一服务相关方面的权利与义务。
      </div>
      <div class="content-div">
        1.2“购买桩权益服务的用户”或“您”是指通过挚达APP享受延长桩权益服务的单个人用户。本协议构成您使用挚达桩权益服务之先决条件除非您接受本协议条款，否则您无权使用本协议的相关服务，您的使用行为将视为同意接受本协议各项条款的约束。
      </div>
      <div class="content-div">
        1.3您在购买桩权益服务前，必须认真审阅并接受或不接受本协议。未成年人应在法定监护人陪同下审阅和履行，未成年人行使和履行本协议项下的权利和义务即视为已获得了法定监护人的认可，您在享受挚达桩权益服务时必须完全、严格遵守本协议条款。
      </div>
      <div class="content-div">
        1.4挚达有权随时对服务条款进行修改，一旦服务条款发生变更和修改，挚达将在相关会员页面上提示修改内容;如果您不同意本协议的修改，可通过上海挚达科技发展股份有限公司客服渠道申请取消已获得的桩权益服务并停止使用;如果您继续使用挚达提供的桩权益服务，则视为已经接受本协议的全部修改。
      </div>

      <div class="line-topic-title">
        2.桩权益服务说明
      </div>

      <div class="content-div">
        2.1挚达桩权益服务所涉及的产品所有权及相关软硬件知识产权，均归挚达APP所属的上海挚达科技发展股份有限公司所有。挚达所提供的桩权益服务将按照服务条款和相关操作规则严格执行您在通过挚达享受任何桩权益服务时，应当接受本协议的约束。
      </div>
      <div class="content-div">
        2.2挚达向您提供的全部服务，均仅限于在挚达平台使用。任何以恶意破解等非法手段将挚达提供的服务内容与挚达平台分离的行为，均不属于本协议中约定的由挚达提供的服务。由此引起的一切法律后果由行为人负责，挚达将依法追究行为人的法律责任。
      </div>
      <div class="content-div">
        2.3当通过挚达使用桩权益服务时，您的使用行为即视为对本服务条款以及挚达在服务中发出各类公告的同意。
      </div>
      <div class="content-div">
        2.4若您已开通桩权益服务，即视为您已明确了解并同意，桩权益的购买支付方式为代收费运营商托收的付款方式(包含微信支付和支付宝支付)。
        您通过此种付费方式付费可能存在一定的商业风险，包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动该等风险均会给您造成相应的经济损失。您应自行承担向侵权方追究侵权责任和追究责任不能的后果
      </div>
      <div class="content-div">
        2.5您应自行负责妥善且正确地保管、使用、维护您在挚达申请取得的账户、账户信息及账户密码，您应对账户信息和账户密码采取必要和有效的保密措施。非挚达原因致使您账户密码泄漏以及因您保管、使用、维护不当造成损失的，挚达无须承担与此有关的任何责任
      </div>
      <div class="content-div">
        2.6挚达不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务和网络接入服务、任意第三方的侵权行为。
      </div>
      <div class="content-div">
        2.7挚达享有对您在网上一切活动的监督、提示、检查的权利。如您的行为违反有关法律法规或违反本协议条款的约定，挚达享有要求其纠正及追究其责任等权利。
      </div>

      <div class="line-topic-title">
        3 购买桩权益程序
      </div>

      <div class="content-div">
        3.1在购买桩权益程序之前，您必须根据真实、准确信息注册成为挚达用户。用户所填写的内容与个人资料必须真实有效，否则挚达有权拒绝您申请或撤销您的桩权益资格，并不￥退还桩权益服务费用或任何赔偿。
        当您的个人资料已发生变化，您应及时修改注册的个人资料，否则由此造成的您桩权益不能全面有效行使的责任由您自己承担，挚达有权因此取消您的桩权益资格，并不予桩权益服务费用或其他任何形式的赔偿。
      </div>
      <div class="content-div">
        3.2桩权益服务包括物联网卡服务包和物联网卡+质保服务包两种形式。挚达用户必须在先购买挚达私人充电桩的基础上，可根据需求自行决定是否继续购买各类服务包。
      </div>
      <div class="content-div">
        “物联网卡服务包”是指，通过挚达购买的物联网卡服务包可根据年限延长用户私人充电桩的联网年限
      </div>
      <div class="content-div">
        “物联网卡+质保服务包”是指，通过挚达购买的物联网卡服务包可根据年限延长用户私人充电桩的联网年限和充电桩质保年限
      </div>
      <div class="content-div">
        3.3挚达用户可挚达APP桩权益服务套餐包，购买支付方式为通过微信、支付宝的第三方支付。无论您使用何种购买方式或支付方式购买桩权益服务，您在购买前必须仔细阅读并确认接受相关服务条款和会员权益使用方法。
        挚达特此声明:挚达从未授权任何第三方单位或个人销售、转让挚达桩权益服务，任何未经授权销售挚达桩权益服务都属于非法销售，挚达有权追究其法律责任。
      </div>
      <div class="content-div">
        3.4挚达仅提供相关的桩权益服务，除此之外与相关桩权益服务有关的设备(如SIM损坏)及所需的费用
        (如换卡人工费、质保以外设备损坏、质保以为维修费用)均应由您自行承担。
      </div>
      <div class="content-div">
        3.5当您购买桩权益服务后，该服务即时生效，且视为您已认可该服务所标明之价格;挚达桩权益服务费用标准以挚达APP上明确标注的售价为准，挚达有权基于自身业务发展需要变更上述服务售价，但挚达会根据实际运营情况对不同阶段已经激活且持续有效的用户给予续费、升级方面的不同优惠，具体优惠政策以挚达在相关服务页面公告的内容为准。
      </div>
      <div class="content-div">
        3.6您购买桩权益服务后，有权利不接受挚达的服务，可通过上海挚达科技发展股份有限公司客服渠道申请取消桩权益服务，但不获得桩权益服务费用的退还
      </div>

      <div class="line-topic-title">
        4.桩权益服务的账号和查询
      </div>

      <div class="content-div">
        4.1桩权益服务的所有权归挚达所有，桩权益服务拥有挚达账号的有限使用权。
      </div>
      <div class="content-div">
        4.2您可通过登录挚达账户，在桩权益服务页面内免费查询您的桩权益服务详情，包括服务状态、服务期限、开通记录等，并通过您的卡券账户查看桩权益服务的使用情况。
      </div>
      <div class="content-div">
        4.3您在使用挚达所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，挚达均不负责任。由于您将个人密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露，挚达不负任何责任。
      </div>
      <div class="line-topic-title">
        5.桩权益服务的期限
      </div>
      <div class="content-div">
        5.1桩权益服务具有固定时效的期限，包括但不限于年卡以及未来增加的更多服务时限，均以用户购买之日起生效。
      </div>
      <div class="content-div">
        有效期：分为年度套餐，桩权益目前已到期，即从购买日启开始计算有效期；桩权益未到期，即从到期日开始累计计算有效；当您购买桩权益服务套餐，即视为您已认可响应的服务期限。
      </div>
      <div class="content-div">
        5.2您在购买桩权益服务套餐后可享受的权益，必须以挚达权益服务页面内所公布的权益为准。挚达有权基于自身业务发展需要变更全部或部分桩权益，就前述权益调整挚达将在权益服务页面进行通知或公告，您也可通过挚达客服渠道查询最新的桩权益。
      </div>
      <div class="content-div">
        5.3挚达桩权益的服务期限，不会因您在充电期间对充电的暂停中断、失败而延长。
      </div>
      <div class="content-div">
        5.4挚达桩权益的服务使用期限已包含挚达解决故障、服务器维修、调整、升级等所需用的合理时间，对上述情况所需用的时间挚达不予补偿并保留解释权。
      </div>
      <div class="line-topic-title">
        6.桩权益服务的权利及限制
      </div>
      <div class="content-div">
        6.1在桩权益服务有效期内，您可根据购买套餐年限延长相应的桩权益期限
      </div>
      <div class="content-div">
        6.2挚达桩权益服务仅限于自行使用，禁止在挚达的不同帐号之间转移桩权益服务，禁止赠与、借用、转让或售卖，否则挚达有权在未经通知的情况下取消转让账户、受让账户的桩权益服务资格，由此带来的损失由您自行承担。
      </div>
      <div class="content-div">
        6.3若您的行为持续违反本协议或违反国家相关法律法规，或挚达认为您的行为有损挚达或他人的声誉及利益，挚达有权取消该您的桩权益资格而无须给与任何形式的补学
      </div>
      <div class="content-div">
        6.4您不得以盗窃、利用系统漏洞等非法途径以及在未获挚达授权的非法销售网站上获取或购买挚达桩权益服务，否则挚达有权取消挚达桩权益的服务资格。由此引发的问题由您自行承担，挚达不负任何责任。
      </div>
      <div class="content-div">
        6.5被取消挚达桩权益的用户，不能再参加由挚达所组织的活动，并不再享有由挚达提供的各项优惠及增值服务权利。
      </div>
      <div class="content-div">
        6.6挚达提供的桩权益服务内容不得用于商业、盈利等用途，仅限个人用户使用。
      </div>
      <div class="content-div">
        6.7禁止以商业目的使用桩权益服务提供的任何服务;包括但不限于下列情况:
      </div>
      <div class="content-div">
        6.7.1通过非法手段对桩权益的服务期限、服务内容进行修改;
      </div>
      <div class="content-div">
        6.7.2通过非挚达认可的方式获得桩权益服务提供的优惠权限;
      </div>
      <div class="content-div">
        6.7.3损害第三方利益，通挚达收集第三方资料信息，破坏或盗取第三方账号，发送诈骗邮件和垃圾邮件等非法信息，侵犯第方合法权益，包括但不限于隐私权、知识产权、财产权等
      </div>
      <div class="line-topic-title">
        7.桩权益服务的中断和终止
      </div>
      <div class="content-div">
        7.1因发生挚达不可抗拒的事由，如政府行为、不可抗力等导致桩权益服务无法继续，挚达会以最快的速度通知您，但不承担由此对挚达造成的任何损失且不退还桩权益服务费用。
      </div>
      <div class="content-div">
        7.2如您违反或被视为违反本协议中的条款，挚达有权在不通知您的情况下立即终止您已购买的所有服务，并取消您的挚达桩权益状态和使用权益，且不退还任何已缴纳的桩权益服务费用。
      </div>
      <div class="content-div">
        7.3挚达未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。挚达随时有权要求您继续履行义务并承担相应的违约责任
      </div>
      <div class="line-topic-title">
        8.协议的变更和修改
      </div>
      <div class="content-div">
        8.1挚达依据本协议的约定变更服务内容、服务方式以及协议内容的，如果您不同意挚达的变更，有权选择取消并停止使用已获取的全部或部分服务;如果您继续使用挚达提供的上述服务，则视为您已经接受挚达的上述调整。
      </div>
      <div class="content-div">
        8.2挚达对桩权益服务协议一旦进行修改，将在页面上公示修改内容，一经公布即视为已通知桩权益。
      </div>
      <div class="content-div">
        8.3您如果不同意条款的修改，可通过国家电网或APP客服渠道主动向挚达提出终止桩权益服务，但挚达不退还自开通桩权益服务至提出终止桩权益服务所在月已享受桩权益服务的部分费用;如果您继续使用桩权益服务，则视为您已接受条款的修改。
      </div>
      <div class="line-topic-title">
        9.法律的适用和管辖
      </div>
      <div class="content-div">
        9.1本协议条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。
      </div>
      <div class="content-div">
        9.2如就本协议内容或其执行发生任何争议，应尽量友好协商解决;协商不成时，则争议各方一致同意将发生的争议提交协商不成时，任何一方均可向上海市杨浦区人民法院提起诉讼
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    init() {},
  },
  mounted() {
    this.init()
  },
}
</script>
